/** Focus handling shared by the learning module's modal dialogs (the Learning editor and the catalog's detail popup). */
export const FOCUSABLE = 'button:not([disabled]), input, textarea, select, [tabindex]:not([tabindex="-1"])';

/** Keep Tab cycling inside the dialog, like the other modals. */
export function trapFocus(event, panel) {
  if (event.key !== "Tab" || !panel) return;
  const items = panel.querySelectorAll(FOCUSABLE);
  if (!items.length) return;
  const first = items[0];
  const last = items[items.length - 1];
  if (event.shiftKey && document.activeElement === first) {
    event.preventDefault();
    last.focus();
  } else if (!event.shiftKey && document.activeElement === last) {
    event.preventDefault();
    first.focus();
  }
}
